import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import io from "socket.io-client";
import './diceComp.scss';

// let socket;
function DialogComp() {
	const dispatch = useDispatch();
	const show = useSelector((state) => state.dice.showDialog);
	// const chosenDice = useSelector((state) => state.dice.chosenDice);
	const highestBet = useSelector((state) => state.dice.highestBet);
	const handleClick = (e) => {
		const value = e.target.getAttribute('data-value');
		// socket.emit("choseDice", { value });
		dispatch({ type: 'MAKE_BET', bet: value });
		dispatch({ type: 'SHOW_DICE', value: false });
		// dispatch({ type: "SHOW_SUIT", value: true });
	};

	const isActive = (value) => {
		// should return true of false based on whether the data value is larger than the highest bet so far
		return value > highestBet ? true : false;
	};
	return show ? (
		<div className="dialog">
			<div>
				<span
					className="d-item dice"
					onClick={handleClick}
					data-value="0"
					data-active="true"
				></span>
				<span
					className="d-item dice"
					onClick={handleClick}
					data-value="1"
					data-active={isActive(1)}
				></span>
				<span
					className="d-item dice"
					onClick={handleClick}
					data-value="2"
					data-active={isActive(2)}
				></span>
				<span
					className="d-item dice"
					onClick={handleClick}
					data-value="3"
					data-active={isActive(3)}
				></span>
				<span
					className="d-item dice"
					onClick={handleClick}
					data-value="4"
					data-active={isActive(4)}
				></span>
				<span
					className="d-item dice"
					onClick={handleClick}
					data-value="5"
					data-active={isActive(5)}
				></span>
			</div>
		</div>
	) : null;
}

export default DialogComp;
